import { CircularProgress } from "@mui/material";

const LoaderWrapper = ({ children, isLoading = false }) => {
  if (isLoading) {
    return (
      <div className="chart-loader">
        <CircularProgress />
      </div>
    );
  } else {
    return children;
  }
};

export default LoaderWrapper;
